import { useEffect, useState } from "react";

const useLocalStorage = (key, defaultValue) => {
	const [value, setValue] = useState(() => {
		let currentValue;

		try {
			currentValue = JSON.parse(
				localStorage.getItem(key) || String(defaultValue),
			);
		} catch {
			currentValue = String(defaultValue);
		}

		return currentValue;
	});

	useEffect(() => {
		localStorage.setItem(key, JSON.stringify(value));
	}, [value, key]);

	const removeItem = () => {
		localStorage.removeItem(key);
		setValue(null);
	};

	return [value, setValue, { removeItem }];
};

export default useLocalStorage;
